<div class="modal-header" id="user-master-modal-title">
    <h3 class="modal-title" id="modal-title" translate="USER_MASTER_SET_TITLE"></h3>
</div>
<div class="modal-body" id="modal-body">
    <table class="table text-center">
        <thead>
            <tr>
                <th class="align-middle" translate="USER_MASTER_SET_SALES_ORG">Sales Org</th>
                <th class="align-middle" translate="USER_MASTER_SET_PLANT">Plant</th>
                <th class="align-middle" translate="USER_MASTER_SET_DESCRIPTION">Plant</th>
                <th class="align-middle"></th>
            </tr>
        </thead>
        <tbody>
            @for (userInfo of model.userMasterData; track userInfo) {
                <tr>
                    <td class="align-middle">{{ userInfo.getSalesOrg() }}</td>
                    <td class="align-middle">{{ userInfo.getPlant() }}</td>
                    <td class="align-middle">{{ userInfo.getDescription() }}</td>
                    <td class="align-middle">
                        <button
                            (click)="setSalesOrgAndPlant(userInfo)"
                            class="btn btn-primary"
                            translate="USER_MASTER_SET_SELECT"
                        ></button>
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>
